import { TranslateService } from "@ngx-translate/core";

export function isAuthenticated(url: string): boolean {
  if (url === "/login" || url === "/") {
    return false;
  } else {
    if (localStorage) {
      return localStorage.getItem("isAuthenticated") &&
        localStorage.getItem("isAuthenticated") === "true"
        ? true
        : false;
    }
  }

  return false;
}

export function setAuthLanguage(translate: TranslateService) {
  switch (navigator.language) {
    case navigator.language.startsWith('pt') ? navigator.language : '':
      translate.use('pt');
      break;
    case navigator.language.startsWith('es') ? navigator.language : '':
      translate.use('es');
      break;
    default:
      translate.use('en');
  }
}
